<kh-dialog-header mat-dialog-title>Bulk Upload {{ siteAlias }} </kh-dialog-header>
<div mat-dialog-content>
    <div class="kh-percentage-text body-large">
        <span class="kh-bold-text">{{ percentComplete }}%&nbsp;</span>
        <span>complete</span>
    </div>
    <mat-progress-bar
        class="khts-mat-progress-bar"
        mode="determinate"
        [value]="percentComplete"
    >
    </mat-progress-bar>
    <div class="kh-notification">
        <kh-inline-notification>
            <div class="body-large kh-bold-text">
                Please keep this window open while we upload your {{ sitesAliasLowerCase }}.
            </div>
            <div class="body-large">This may take a few minutes.</div>
        </kh-inline-notification>
    </div>
</div>
